// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Zaxyt","list":"BalanceDue_list__EZXp2","listRow":"BalanceDue_listRow__2ohFQ","total":"BalanceDue_total__EdJG1"};